var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-plus"},[_c('div',_vm._g({staticClass:"app-plus__inner"},_vm.listeners),[_c('plus-icon'),_c('span',{staticClass:"forMobile_or_p"},[_vm._v("Добавить")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }